import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// MARQUE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_MARQUE_SUCCESS =  type('CATALOGUE_MARQUE_SUCCESS')
export const CATALOGUE_MARQUE_ERROR =  type('CATALOGUE_MARQUE_ERROR')

//////////////////////////////////////////////////////////////////
// REFERENCE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_REFERENCE_SUCCESS =  type('CATALOGUE_REFERENCE_SUCCESS')
export const CATALOGUE_REFERENCE_ERROR =  type('CATALOGUE_REFERENCE_ERROR')

//////////////////////////////////////////////////////////////////
// TREE
/////////////////////////////////////////////////////////////////
export const CATALOGUE_TREE_SUCCESS =  type('CATALOGUE_TREE_SUCCESS')
export const CATALOGUE_TREE_ERROR =  type('CATALOGUE_TREE_ERROR')

//////////////////////////////////////////////////////////////////
// META
/////////////////////////////////////////////////////////////////
export const CATALOGUE_META_SUCCESS =  type('CATALOGUE_META_SUCCESS')
export const CATALOGUE_META_ERROR =  type('CATALOGUE_META_ERROR')

export const CATALOGUE_META_DETAIL_SUCCESS =  type('CATALOGUE_META_DETAIL_SUCCESS')
export const CATALOGUE_META_DETAIL_ERROR =  type('CATALOGUE_META_DETAIL_ERROR')

export const CATALOGUE_META_SAVE_SUCCESS =  type('CATALOGUE_META_SAVE_SUCCESS')
export const CATALOGUE_META_SAVE_ERROR =  type('CATALOGUE_META_SAVE_ERROR')

export const CATALOGUE_META_DELETE_SUCCESS =  type('CATALOGUE_META_DELETE_SUCCESS')
export const CATALOGUE_META_DELETE_ERROR =  type('CATALOGUE_META_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// FLUXBUILDER
/////////////////////////////////////////////////////////////////
export const CATALOGUE_FLUXBUILDER_SUCCESS =  type('CATALOGUE_FLUXBUILDER_SUCCESS')
export const CATALOGUE_FLUXBUILDER_ERROR =  type('CATALOGUE_FLUXBUILDER_ERROR')

export const CATALOGUE_FLUXBUILDER_DETAIL_SUCCESS =  type('CATALOGUE_FLUXBUILDER_DETAIL_SUCCESS')
export const CATALOGUE_FLUXBUILDER_DETAIL_ERROR =  type('CATALOGUE_FLUXBUILDER_DETAIL_ERROR')

export const CATALOGUE_FLUXBUILDER_SAVE_SUCCESS =  type('CATALOGUE_FLUXBUILDER_SAVE_SUCCESS')
export const CATALOGUE_FLUXBUILDER_SAVE_ERROR =  type('CATALOGUE_FLUXBUILDER_SAVE_ERROR')

export const CATALOGUE_FLUXBUILDER_DELETE_SUCCESS =  type('CATALOGUE_FLUXBUILDER_DELETE_SUCCESS')
export const CATALOGUE_FLUXBUILDER_DELETE_ERROR =  type('CATALOGUE_FLUXBUILDER_DELETE_ERROR')